import {API_URL, authHeaders, jsonHeaders} from "./index";

export async function apiLogin(username, password) {
    const res = await fetch(`${API_URL}/login`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({username, password})
    });
    return res.json();
}

export async function apiRegister(email, username, password, cguAccepted) {
    const res = await fetch(`${API_URL}/register`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email, username, password, cguAccepted})
    });
    return res.json();
}

export async function apiMe() {
    const res = await fetch(`${API_URL}/me`, {headers: authHeaders()});
    if (!res.ok) return null;
    return res.json();
}

export async function apiConfig() {
    const res = await fetch(`${API_URL}/config`);
    return res.json();
}

export async function apiChangePassword(oldPassword, newPassword) {
    const res = await fetch(`${API_URL}/change-password`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({oldPassword, newPassword})
    });
    return res.json();
}

export async function apiUpdateProfile(username, email, recoveryEmail) {
    const res = await fetch(`${API_URL}/update-profile`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({username, email, recovery_email: recoveryEmail})
    });
    return res.json();
}

export async function apiForgotPassword(email) {
    const res = await fetch(`${API_URL}/forgot-password`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email})
    });
    return res.json();
}

export async function apiForgotPseudo(email) {
    const res = await fetch(`${API_URL}/forgot-pseudo`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email})
    });
    return res.json();
}

export async function apiResetPassword(token, newPassword) {
    const res = await fetch(`${API_URL}/reset-password`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({token, newPassword})
    });
    return {ok: res.ok, data: await res.json()};
}

export async function apiGetPseudoSuggestions() {
    const res = await fetch(`${API_URL}/suggest-pseudonyms?count=3`);
    return res.json();
}

export async function apiResendVerification(email) {
    const res = await fetch(`${API_URL}/resend-verification`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email})
    });
    return res.json();
}

export async function apiConfirmEmailChange(token) {
    const res = await fetch(`${API_URL}/confirm-email-change`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({token})
    });
    return {ok: res.ok, data: await res.json()};
}

export async function apiVerifyEmail(token) {
    const res = await fetch(`${API_URL}/verify-email`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({token})
    });
    return {ok: res.ok, data: await res.json()};
}
